import React from "react";
import {useSortable} from "@dnd-kit/sortable";

import './SortableItem.css';

const SortableItem = (props) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: props.id,
        disabled: props.disabled,
    });

    const style = {
        '--translate-x': transform ? `${transform.x}px` : 0,
        '--translate-y': transform ? `${transform.y}px` : 0,
        transition,
    };

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners} className={`sortable-item ${isDragging ? 'dragging' : ''}`}>
            {props.children}
        </div>
    );
}

export default SortableItem;